<template>
<div style="height:100%">
<!-- <div class="pb-2"> -->
    <v-toolbar flat dark class="primary no-print" mb-2>
        <v-toolbar-title>Monthly Living Expenses {{total | currency}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu>
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon>
                <v-icon>more_vert</v-icon>
            </v-btn>
            </template>
            <v-list>             
                <v-list-item @click="save"> 
                    <v-list-item-title>Save for Later</v-list-item-title>
                </v-list-item> 
                <v-list-item v-if="step == 2" @click="showExample"> 
                    <v-list-item-title>Show Example</v-list-item-title>
                </v-list-item> 
            </v-list>            
        </v-menu>

    </v-toolbar> 
<!-- </div> -->
 

<div class="print-only">
    <h2>Living Expense Worksheet for {{params.name}}</h2>
</div>

<v-container style="height:100%;overflow-y:auto" class="pa-1 pb-4">

<!-- ****** Step 1 ******* -->

<v-stepper v-model="step" vertical class="living-expenses">
    <v-stepper-step :complete="step > 1" step="1" >
        <div class="clickable" @click="step = 1">
            <div style="font-size:16px;color:#444;">About your household</div>
            <small style="color:#555">{{houseHoldSummary}}</small>
        </div>
    </v-stepper-step>

    <v-stepper-content step="1">
        <v-row wrap>
            <v-col xs12 sm8>
                <div class="pr-4">
                    <div class="mb-3 inset-text" style="margin-top:0px">
                        This should take just a couple of minutes. To comply with government regulation, we need some information about your living expenses. Do not include rent or debts. These are assessed separately.
                    </div>
                    <v-text-field v-model="params.name" label="Your Name/s" @change="nameChanged" xhide-details/>
                    <v-text-field v-model="params.email" label="Your Email" xhide-details />
                    <div style="display:flex">
                        <v-text-field v-model="params.consultant" :disabled="mode == 'invitation'" label="Consultants Email" @input="linkCopied = false" />
                        <v-btn v-if="clientLinkVisible" @click.native="getClientLink">Get Client Link</v-btn>
                    </div>

                </div>

            </v-col>
            <v-col xs12 sm4>
                <div style="border-radius:5px" class="mb-4 pa-4 grey lighten-3">
                    <div style="font-weight:bold;font-size:12px;color:#888;margin-top:-10px;margin-bottom:-10px">Your household</div>
                    <v-select v-model="params.adults" :items="adultItems" label="Adults" single-line hide-details @change="adultsChanged" />
                    <v-select v-model="params.children" :items="childrenItems" label="Dependent Children" single-line hide-details />
                    <!-- <div v-if="params.children > 0">
                        <v-switch v-model="params.private" label="Private School" hide-details/>
                        <v-switch v-model="params.daycare" label="Daycare" hide-details />
                    </div> -->
                    <!-- <v-select v-model="params.cars" :items="carItems" label="Cars" single-line hide-details /> -->
                    <!-- <v-select v-model="params.investments" :items="investmentItems" label="Investment Properties" single-line hide-details /> -->
                    <v-select v-model="params.income" :items="['Low Income', 'Average Income', 'High Income']" label="Household Income" single-line hide-details />
                </div>
            </v-col>
        </v-row>

        <div style="width:100%;display:flex;">
            <!-- <v-btn v-if="mode != 'invitation'" color="grey" outline @click="" v-show="!stepOneValidation">Send Invite</v-btn> -->
            <v-spacer />
            <div style="text-align:right">
                <v-btn color="primary" @click="step = 2" :disabled="Boolean(stepOneValidation)">Continue to Next Step</v-btn>
                <div class="validation-error">{{stepOneValidation}}</div>
            </div>
        </div>
    </v-stepper-content>

    <!-- ****** Step 2 ******* -->

    <v-stepper-step  :complete="step > 2" step="2">
        <div  :class="{clickable: !stepOneValidation}" @click="stepTwoClicked">
            <div style="font-size:16px;color:#444;">Monthly Expenses</div>
            <small style="color:#555">{{stepTwoSubtitle}}</small>
        </div>
               
          
    </v-stepper-step>
  
    <v-stepper-content step="2">

        <div class="pl-3">
            <LivingExpense v-for="(expense, index) in expenses" :expense="expense" :key="index"  />
        </div>
        
        <div style="float:right;text-align:right">
            <v-btn text @click="step = 1">Back</v-btn>
            <v-btn :disabled="Boolean(stepTwoValidation)" color="primary" @click="step = 3">Continue</v-btn>
            <div class="validation-error">{{stepTwoValidation}}</div>
        </div>
    </v-stepper-content>

    <!-- ****** Step 3 ******* -->

    <v-stepper-step :complete="submitted" step="3">
        <div :class="{clickable: !stepTwoValidation}" @click="stepThreeClicked">
            <div style="font-size:16px;color:#444;">Submit your information</div>
            <small style="color:#555"></small>
        </div>  
    </v-stepper-step>

    <v-stepper-content step="3">
        <div v-if="submitted" class="pa-2 grey--text text--darken-2" max-width="500px">
            <v-icon color="green" style="font-size:50px;margin-right:10px;float:left">check_circle_outline</v-icon>
            <div style="font-size:20px;color:#999;font-weight:200;">Thank you.</div>Your answers have been recorded. You may close this window. 
        </div>

        <template v-else>

            <div v-if="!totalWithinRange" style="max-width:500px">
                <div v-if="totalRangeError" class="no-print grey--text text--darken-1">
                    <v-icon color="red lighten-2" style="float:left;margin-right:10px">report_problem</v-icon>
                    <span>
                        Your total living expenses of {{total}} is {{totalHigherOrLower}} than expected, Your lender will require an explanation why. Otherwise you can
                        <a href="" @click.prevent="step = 2" >go back and review your answers</a>
                    </span>
                </div>
                <v-textarea outline class="no-print mt-2" label="" single-line  :rows="2" v-model="params.explanation" />
            </div>


            <div v-if="!submitted" class="pa-3 mb-3 elevation-2" style="border:solid 1px #ccc;border-radius:8px;max-width:500px">
                <v-btn :disabled="totalRangeError" @click="sendSubmission" style="float:right">Send Now</v-btn>
                <div style="font-size:16px;color:#777">Ready to Send</div> 
                <div style="width:40px;font-weight:600;display:inline-block">To: </div>{{this.params.consultant}}<br/>
                <template v-if="this.params.email">
                <div style="width:40px;font-weight:600;display:inline-block">Cc: </div>{{this.params.email}}
                </template>
            </div>

        </template> 

        <!-- <div class="pa-3 grey--text"> Here's a summary of the expenses that will be submitted.</div> -->

        <!-- Inline styles for emailing html to client -->
        <table ref="expenses" style="width:100%; max-width:500px; border-collapse:collapse">
  
            <tr>
                <td colspan="2" style="border-bottom: solid 1px #bbb;padding: 8px;"><b>{{params.name}}</b></td>
            </tr>
            <tr>
                <td colspan="2" style="border-bottom: solid 1px #bbb;padding: 8px;">{{houseHoldSummary}}</td>
            </tr>
            <tr>
                <td style="border-bottom: solid 1px #bbb;padding: 8px;">
                    <b>Living Expenses</b>
                    <div v-if="params.explanation">
                        {{params.explanation}}
                    </div>
                </td>
                <td style="border-bottom: solid 1px #bbb;padding: 8px;" align="right">{{total | currency}}</td>
            </tr>
            <tr>
                <td style="border-bottom: solid 1px #bbb;padding: 8px;"><b>Breakdown</b></td>
                <td style="border-bottom: solid 1px #bbb;padding: 8px;" align="right"></td>
            </tr>            
            <template v-for="expense in expenses">
                <tr :key="expense.name">
                    <td style="border-bottom: solid 1px #bbb;padding: 8px;">
                        <b>{{expense.name}}</b>
                        <div v-if="expense.explanation">
                            {{expense.explanation}}
                        </div>
                    </td>
                    <td style="border-bottom: solid 1px #bbb;padding: 8px;" align="right" valign="top">
                        {{expense.value | currency}}
                        <span v-if="expense.na">Not Applicable</span>
                    </td>
                </tr>  
            </template>          
        </table>
        <!-- <div style="float:right">
            <v-btn text @click="step = 2">Back</v-btn>
            <v-btn color="primary" @click="step = 1">Submit</v-btn>
        </div> -->
    </v-stepper-content>

  </v-stepper>

</v-container>  

<!-- <v-snackbar bottom :timeout="4000" v-model="alertVisible"> {{ alertMessage }} </v-snackbar> -->


</div>
</template>

<script>
import NumberHelpers from '@/helpers/NumberHelpers'
import LivingExpense from './LivingExpense'
import EmailHelpers from '@/helpers/EmailHelpers'
import DataHelpers from '@/helpers/DataHelpers'
import FirebaseHelpers from '@/helpers/FirebaseHelpers'
import FireData from '@/data/FireData'
import StringHelpers from '@/helpers/StringHelpers'
import AlertHelpers from '../../helpers/AlertHelpers';
import clipboard from 'clipboard-js'
import LivingExpenseHelpers from './LivingExpenseHelpers'


    export default {
        name: 'LivingExpenses',
        data() {
            return {
                linkCopied: false,
                sendCopy: false,
                submitted: false,
                mode: 'normal',
                step: 1,
                stepVisible:false,
                params: {
                    name: '',
                    email: '',
                    consultant: '',
                    adults: 2,
                    children : 0,
                    daycare: false,
                    private: false,
                    cars: 2,
                    investments: 0,
                    income: 'Average Income',
                    explanation: '',
                },
                expenses: {

                    a_groceries: {
                        name: 'Groceries',
                        value:  0,
                        explanation: '',
                        hint: "Food, household supplies",
                        expectedValue: 101,
                        max: 300,
                        na: false,
                        breakdown: [
                            {
                                name: 'Food',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Household Supplies',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Other',
                                value: 0,
                                frequency: 'm'
                            },
                        ]
                    },

                    b_clothing: {
                        name: 'Clothing and Personal',
                        value:  0,
                        explanation: '',
                        hint: "Clothes, accessories, cosmetics etc",
                        expectedValue: 101,
                        max: 300,
                        na: false,
                        breakdown: [
                            {
                                name: 'Clothing',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Accessories',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Cosmetics',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Other',
                                value: 0,
                                frequency: 'm'
                            },
                        ]
                    },
                    c_transport: {
                        name: 'Transport',
                        value:  0,
                        explanation: '',
                        hint: "Includes fuel, servicing, public transport, rego, parking, tolls (but not leases/loans)",
                        expectedValue: 101,
                        max: 300,
                        na: false,
                        breakdown: [
                            {
                                name: 'Fuel',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Servicing',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Public Transport',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Registration',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Parking',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Tolls',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Other',
                                value: 0,
                                frequency: 'm'
                            },
                        ]                         
                    },                    

                    d_communication: {
                        name: 'Telephone, Internet, Pay TV',
                        value:  0,
                        explanation: '',
                        hint: "Phone, internet, TV Subscriptions",
                        expectedValue: 101,
                        max: 300,
                        na: false,
                        breakdown: [
                            {
                                name: 'Phones',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Internet',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'TV Subscriptions',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Other',
                                value: 0,
                                frequency: 'm'
                            },
                        ]                        
                    },      

                    e_entertainment: {
                        name: 'Recreation and Entertainment',
                        value:  0,
                        explanation: '',
                        hint: "Movies, gym, dining, alcohol, tobacco, holdays",
                        expectedValue: 101,
                        max: 300,
                        na: false,
                        breakdown: [
                            {
                                name: 'Holidays',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Tobacco/Alcohol',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Movies/Dining Out',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Gym',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Other',
                                value: 0,
                                frequency: 'm'
                            },
                        ]                         
                    },

                    f_childcare: {
                        name: 'Childcare',
                        value:  0,
                        explanation: '',
                        hint: "Child care for young children",
                        expectedValue: 101,
                        max: 300,
                        na: false,
                        optional: true,
                        breakdown: [
                            {
                                name: 'Daycare (after rebates)',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Nannies/Sitters',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Other',
                                value: 0,
                                frequency: 'm'
                            },
                        ]                         
                    },

                    g_petcare: {
                        name: 'Pet Care',
                        value:  0,
                        explanation: '',
                        hint: "Food and care for pets",
                        expectedValue: 0,
                        max: 300,
                        optional: true,
                        na: false,
                        breakdown: [
                            {
                                name: 'Pet Food',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Vetinary',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Other',
                                value: 0,
                                frequency: 'm'
                            },
                        ]                         
                    },                    

                    h_medical: {
                        name: 'Medical and Health',
                        value:  0,
                        explanation: '',
                        hint: "Doctor, dentist, physio, prescriptions",
                        expectedValue: 101,
                        max: 300,
                        na: false,
                        breakdown: [
                            {
                                name: 'Doctor',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Dentist',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Physio/Chiro',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Prescriptions',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Other',
                                value: 0,
                                frequency: 'm'
                            },
                        ] 
                    },

                    i_health_insurance: {
                        name: 'Health Insurance',
                        value:  0,
                        explanation: '',
                        hint: "Health insurance premiums",
                        expectedValue: 100,
                        max: 300,
                        optional: true,
                        na: false,
                        breakdown: [
                            {
                                name: 'Health Premium',
                                value: 0,
                                frequency: 'm'
                            },
                        ] 
                    },

                    j_general_insurance: {
                        name: 'General Basic Insurance',
                        value:  0,
                        explanation: '',
                        hint: "Cars and other assets",
                        expectedValue: 101,
                        max: 300,
                        na: false,
                        optional: false,
                        breakdown: [
                            {
                                name: 'Car Insurance',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Other Insurance',
                                value: 0,
                                frequency: 'm'
                            },
                        ]                         
                    },                    
                    k_risk_insurance: {
                        name: 'Sickness, Accident, Life Insurance',
                        value:  0,
                        explanation: '',
                        hint: "Risk, Trauma, Life",
                        expectedValue: 101,
                        max: 300,
                        optional: true,
                        na: false,
                        breakdown: [
                            {
                                name: 'Life',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Risk',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Trauma',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Other',
                                value: 0,
                                frequency: 'm'
                            },
                        ]                         
                    },                    

                    l_public_education: {
                        name: 'Public School',
                        value:  0,
                        explanation: '',
                        hint: "Courses, school fees, books",
                        expectedValue: 101,
                        max: 300,
                        optional: true,
                        na: false,
                        breakdown: [
                                {
                                    name: 'School Fees',
                                    value: 0,
                                    frequency: 'm'
                                },
                                {
                                    name: 'Books/Stationary',
                                    value: 0,
                                    frequency: 'm'
                                },
                                {
                                    name: 'Courses',
                                    value: 0,
                                    frequency: 'm'
                                },
                                {
                                    name: 'Other',
                                    value: 0,
                                    frequency: 'm'
                                },
                            ]                         
                    },
                    m_private_education: {
                        name: 'Private School',
                        value:  0,
                        explanation: '',
                        hint: "Courses, school fees, books",
                        expectedValue: 101,
                        max: 300,
                        optional: true,
                        na: false,
                        breakdown: [
                                {
                                    name: 'School Fees',
                                    value: 0,
                                    frequency: 'm'
                                },
                                {
                                    name: 'Books/Stationary',
                                    value: 0,
                                    frequency: 'm'
                                },
                                {
                                    name: 'Courses',
                                    value: 0,
                                    frequency: 'm'
                                },
                                {
                                    name: 'Other',
                                    value: 0,
                                    frequency: 'm'
                                },
                            ]                         
                    },

                    n_higher_education: {
                        name: 'Higher Education',
                        value:  0,
                        explanation: '',
                        hint: "Tafe, Uni, Personal Development",
                        expectedValue: 101,
                        max: 300,
                        na: false,
                        optional: true,
                        breakdown: [
                            {
                                name: 'University/College',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'TAFE',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Courses',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Other',
                                value: 0,
                                frequency: 'm'
                            },
                        ]                         
                    },                    

                    o_home_costs: {
                        name: 'Home Rates and Utilities',
                        value:  0,
                        explanation: '',
                        hint: "Council rates, electricity, gas (INCLUDES PURCHASE PROPERTY)",
                        expectedValue: 101,
                        max: 300,
                        na: false,
                        breakdown: [
                            {
                                name: 'Council Rates',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Electricity',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Gas',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Water',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Other',
                                value: 0,
                                frequency: 'm'
                            },
                        ]                         
                    },
                    p_investment: {
                        name: 'Investment Property',
                        value:  0,
                        explanation: '',
                        hint: "Council rates, strata, repairs",
                        expectedValue: 101,
                        max: 300,
                        optional: true,
                        na: false,
                        breakdown: [
                            {
                                name: 'Council Rates',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Body Corp Fees',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Repairs',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Other',
                                value: 0,
                                frequency: 'm'
                            },
                        ]                         
                    },                    
                    q_secondary_property: {
                        name: 'Secondary Residence Running Costs',
                        value:  0,
                        explanation: '',
                        hint: "Council rates, strata, repairs",
                        expectedValue: 101,
                        max: 300,
                        optional: true,
                        na: false,
                        breakdown: [
                            {
                                name: 'Council Rates',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Body Corp Fees',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Repairs',
                                value: 0,
                                frequency: 'm'
                            },
                            {
                                name: 'Other',
                                value: 0,
                                frequency: 'm'
                            },
                        ]                         
                    },                    
                    r_other: {
                        name: 'Other',
                        value:  0,
                        explanation: '',
                        hint: "Anything else",
                        expectedValue: 0,
                        max: 300,
                        optional: true,
                        na: false,
                        breakdown: [
                            {
                                name: 'Other',
                                value: 0,
                                frequency: 'm'
                            },
                        ]                         
                    },                              
                }
            }
        },
        components:{
            LivingExpense
        },
        computed:{

            expectedTotal() {

                const PER_ADULT = 1450
                const PER_CHILD = 500

                let total = this.params.adults * PER_ADULT + this.params.children * PER_CHILD
                if(this.params.income == 'Low Income')
                    total = total * 0.93
                if(this.params.income == 'High Income')
                    total = total * 1.2
                return total
            },

            path() {
                if(!this.key)
                    return ''

                return StringHelpers.rootPath() + 'living?k=' + this.key
            },

            alertVisible: {
                get: function() {
                    return this.$store.getters.alert.message
                },
                set: function(newValue) {
                    if(!newValue)
                        this.$store.dispatch('clearAlert')
                }
            },
            alertMessage() {
                return this.$store.getters.alert.message
            },


            totalRangeError() {
                return (
                    !this.totalWithinRange && this.params.explanation.length < 3
                )
            },

            totalWithinRange() {
                const diff = Math.abs(this.expectedTotal - this.total)
                    return (diff / this.expectedTotal) < 0.1
            },

            totalHigherOrLower() {
                if(this.total > this.expectedTotal)
                    return 'higher'
                else
                    return 'lower'
            },

            houseHoldSummary() {
                return(
                    this.params.adults + ' adults, '
                    + this.params.children + ' children, '
                    + (this.params.private ? 'Private School, ' : '')
                    + (this.params.daycare ? 'Daycare, ' : '')
                    + this.params.cars + ' cars, '
                    + this.params.investments  + ' investments'
                )
            },
            stepOneValidation() {
                let validationErrors = []
                if(this.params.name.length < 5)
                    validationErrors.push('Require valid name')
                if(this.params.consultant.length < 5)
                    validationErrors.push('Require valid consultant')
                if(!StringHelpers.isEmail(this.params.email))
                    validationErrors.push('Require valid email')
                return StringHelpers.sentenceJoin(validationErrors)
            },

            stepTwoValidation() {
                let validationErrors = []
                for(const property in this.expenses) {
                    if(!this.isValid(this.expenses[property]) )
                        validationErrors.push(this.expenses[property].name)
                }
                if(validationErrors.length)
                    return 'Require ' + StringHelpers.sentenceJoin(validationErrors)   
                else
                    return ''             
            },

            adultItems() {
                return [
                    {text: '1 Adult', value: 1},
                    {text: '2 Adults', value: 2},
                ]
            },

            childrenItems() {
                return [
                    {text: 'No Children', value: 0},
                    {text: '1 Child', value: 1},
                    {text: '2 Children', value: 2},
                    {text: '3 Children', value: 3},
                    {text: '4 or more!', value: 4},
                ]
            },
            carItems() {
                return [
                    {text: 'No Cars', value: 0},
                    {text: '1 Cars', value: 1},
                    {text: '2+ Cars', value: 2},
                ]
            },
            investmentItems() {
                return [
                    {text: 'No Investments', value: 0},
                    {text: '1 Investment Property', value: 1},
                    {text: '2+ Investment Properties', value: 2},
                ]
            },
            total() {
                let total = 0
                for(const property in this.expenses) {
                    let value = this.expenses[property].value || 0
                    total += parseInt(value)
                }
                return total
            }, 
            stepTwoSubtitle() {
                if(this.total < 300 && this.step == 2)
                    return "Do not include rent or debts. They are assessed separately"

                return "Please select a number for each expense category"
            },
            clientLinkVisible() {
                let validEmail = StringHelpers.isEmail(this.params.consultant)
                return validEmail && this.mode == 'normal' && !this.linkCopied
            }

        },
        methods: {
            isValid(expense) {
                return LivingExpenseHelpers.isValid(expense)
            },

            setExpectations() {
                console.log('setting expectations')

                let e = this.expenses

                let scaling = 1
                if(this.params.income == 'High Income')
                    scaling = 1.2
                if(this.params.income == 'Low Income')
                    scaling = 0.8
        
                e.a_groceries.expectedValue = (200 + this.params.adults * 300 + this.params.children * 180) * scaling
                e.b_clothing.expectedValue = (this.params.adults * 100 + this.params.children * 40) * scaling
                e.c_transport.expectedValue = 300 * scaling
                e.d_communication.expectedValue = (this.params.adults * 100 + this.params.children * 20) * scaling
                e.e_entertainment.expectedValue = (this.params.adults * 250 + this.params.children * 100) * scaling
                e.f_childcare.expectedValue = 200
                e.g_petcare.expectedValue = 100
                e.h_medical.expectedValue = (this.params.adults * 50 + this.params.children * 30) * scaling
                e.i_health_insurance.expectedValue = (this.params.adults * 150 + this.params.children * 80) * scaling
                e.j_general_insurance.expectedValue = 100
                e.j_general_insurance.optional = true
                e.k_risk_insurance.expectedValue = 100
                e.l_public_education.expectedValue = this.params.children * 80
                e.m_private_education.expectedValue = this.params.children * 400
                e.n_higher_education.expectedValue = 100
                e.o_home_costs.expectedValue = (220 + this.params.adults * 50)
                e.p_investment.expectedValue = 200
                e.p_investment.optional = true
                e.q_secondary_property.expectedValue = 300
                //r_other doesn't change....

                for(let prop in e) {
                    e[prop].max = this.nearestTen(e[prop].expectedValue * 2) || 100
                }
            },

            nameChanged() {
                if(this.params.name == 'demo') {
                    this.params.name = 'Jenkin Hanmington'
                    this.params.consultant = 'matt.ireland.home@gmail.com'
                    this.params.email = 'matt.ireland.home@gmail.com'
                }
            },
    
            getClientLink() {
                let linkPath = StringHelpers.rootPath() + 'living/?r=' + this.params.consultant
                clipboard.copy({'text': linkPath})
                this.linkCopied = true
                AlertHelpers.showAlert('Link copied to clipboard')
            },
            showExample() {
                for(let prop in this.expenses) {
                    this.expenses[prop].value = this.expenses[prop].expectedValue
                }
            },

            nearestTen(num) {
                return parseInt(num / 10) * 10
            },

            stepTwoClicked() {
                if(!this.stepOneValidation) {
                    this.step = 2
        
                }
            },
            stepThreeClicked() {
                if(!this.stepTwoValidation) {
                    this.step = 3
        
                }

            },

            sendSubmission() {
                this.save()
                let subject = 'Living Expenses - ' + this.params.name
                let linkBack = '<a href="' + this.path + '">' + subject + '</a>'

                let expenses = this.$refs.expenses.innerHTML

                let email = EmailHelpers.createEmail()
                email.service = 'living_expenses'
                email.to = this.params.consultant
                email.cc = this.params.email || null
                email.from = 'expense.estimation@gmail.com'
                email.fromName = 'Living Expense Tool'
                email.subject = 'Living Expenses - ' + this.params.name
                email.body = "You've been sent a living expenses simulation. <br/><br/>" + "You can revisit this simulation using this link: " + linkBack + "<br/><br/>" + expenses
                EmailHelpers.sendEmailJS(email).then(response => {
                    if(response.text == 'OK') {
                        this.submitted = true
                        AlertHelpers.showAlert('Email sent successfully')
                    }
                    else
                        AlertHelpers.showAlert('Email Failed: ' + response.text)
                })
            },


            adultsChanged() {
                this.params.cars = this.params.adults
            },

            save() {
                if(!this.key)
                    this.key = DataHelpers.getKey()
                let record = {
                    key: this.key,
                    params: this.params,
                    expenses: this.expenses,
                }

                let ref = DataHelpers.getRootRef().child('app/livingExpenses')
                FirebaseHelpers.saveToFirebase(record, ref)
            },

            load() {
                
                let ref = DataHelpers.getRootRef().child('app/livingExpenses').child(this.key)
                FireData.fetchItemSingle(ref).then(record => {
                    console.log(record)
                    this.expenses = record.expenses
                    this.params = record.params
                })
            }
        },
        watch: {
            step: function(newVal, oldVal) {
                if(newVal == 2 && oldVal == 1)
                    this.setExpectations()
                    
            },

            total: function(newVal) {
                this.submitted = false
            }

        },
        created() {
            let replyAddress = this.$route.query.r || null
            if(replyAddress) {
                this.params.consultant = replyAddress
                this.mode = 'invitation'
            }

            this.key = this.$route.query.k || null
            if(this.key) {
                this.load()
            }

        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>





</style>

<style>
.living-expenses .v-stepper__step__step {
    font-size: 18px!important;
    width: 32px!important;
    height: 32px!important;
}
.living-expenses.v-stepper {
    box-shadow: none;
    margin-left: -15px;
}
.validation-error {
    color: #EF9A9A;
}
</style>


// WEBPACK FOOTER //
// LivingExpenses.vue?82af1b40